<template>
  <v-menu no-click-animation :scrim="false">
    <template v-slot:activator="{ props }">
      <v-card
          height="100%"
          rounded="0"
          variant="flat"
          v-bind="props">
        <slot name="activator"/>
      </v-card>
    </template>
    <v-list>
      <template v-for="item in items" :key="item.id">
        <v-divider v-if="item.id=='separator'"/>
        <v-list-item v-else
                     :disabled="item.disabled || alertIsDisabled(item)"
                     @click="onSelectedTabChange(item, originalTab)" :id="item.id">
          <template #title>
            <v-sheet class="d-flex flex-row align-center">
              <v-icon :icon="item.icon" class="mr-2" size="large" :color="item.color"/>
              <span :class="'text-'+item.color">{{ item.label as string }}</span>
            </v-sheet>
          </template>
          <template v-if="item.subItems" v-slot:append>
            <v-icon icon="mdi-chevron-right" size="x-small"></v-icon>
          </template>
          <v-menu v-if="item.subItems" :open-on-focus="false" activator="parent" open-on-hover submenu>
            <v-list>
              <template v-for="subItem in item.subItems" :key="subItem.id">
                <v-divider v-if="subItem.id=='separator'"/>
                <v-list-item v-else
                             :disabled="alertIsDisabled(subItem)"
                             @click="onSelectedTabChange(subItem, originalTab)">
                  <template #prepend>
                    <v-sheet class="d-flex flex-row align-center">
                      <v-icon :icon="subItem.icon" class="mr-2" size="large"/>
                      <span>{{ subItem.label as string }}</span>
                    </v-sheet>
                  </template>
                </v-list-item>
              </template>
            </v-list>
          </v-menu>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>


</template>
<script setup lang="ts">
import type {MenuItem, OriginalTab} from "~/types/Tab";

defineProps<{
  items: MenuItem[]
  onSelectedTabChange: (item: MenuItem, originalTab: OriginalTab) => void
  alertIsDisabled: (item: MenuItem) => boolean
  originalTab: OriginalTab
}>()
</script>
